module.exports = __webpack_public_path__ + "static/media/drawer-background.78ef385e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/drawer-background.jpg
// module id = 1074
// module chunks = 0